import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import cirlogo from "../../images/cir-logo.png";
import { API_URL } from "../../../Config";
import { useParams } from "react-router-dom";
import { OKIcon } from "react-share";
import {
  Row,
  Col,
  Container,
  Button,
  ModalHeader,
  ModalFooter,
  Modal,
  ModalBody,
  Alert,
} from "reactstrap";

const PayDeposit = () => {
  const [depositData, setDepositData] = useState(null);
  const [loading, setLoading] = useState(true);
    const [successModal, setsuccessModal] = useState(false);
  
  const successToggleModal = () => setsuccessModal(!successModal);



  const [loaderModal, setLoaderModal] = useState(false);
  const loaderToggle = () => setLoaderModal(!loaderModal);

  const { id } = useParams()
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    fetch(API_URL + "/get/deposit/data/" + id)
      .then((res) => res.json())
      .then((data) => {
        setDepositData(data.data[0]);
        setLoading(false);
        payNow(data.data[0])
      })
      .catch((err) => {
        console.error("Error fetching deposit data:", err);
        setLoading(false);
      });
  }


  const payNow = (balance) => {
    $("#paypal-button-container").html('')

  paypal
      .Buttons({
        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value: parseFloat(balance.paymentAmount),
                },
              },
            ],
          });
        },
        onApprove: function (data, actions) {
          return actions.order.capture().then(async function  (details) {
            //   console.log(details)
            
                      loaderToggle()
                       const requestUrl =  API_URL + "/complete/balance/payment/" + id
                          const response = await fetch(requestUrl, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              orderID: details.id,                              
                            }),
                          });
                      
                          const data = await response.json();
                      
                          if (data.success) {
                            successToggleModal()
                            getData()
                          }
          });
        },
        onCancel: function (data) {
          // window.location.replace("<?php echo $site_url;?>sales/CeRegister_new_back.php")
        },
      })
      .render("#paypal-button-container");

   
  }

  return (
    <Box
      sx={{
        width: "600px",
        m: "0 auto",
        p: 1,
        // textAlign: "center",
        mt: 5,
      }}
    >
      <Box>
        <div className="cir-logo" style={{ textAlign: "center" }}>
          <a href="/">
            <img src={cirlogo} alt="logo" />
          </a>
          <h5 style={{ fontSize: "24px", paddingTop: "1rem", color: "#818DCB" }}>
            Professional School of Behavioral Health Sciences
          </h5>
        </div>
        <Box
          sx={{
            border: "2px solid #818DCB",
            p: 2,
            mt: 4,
            flex: 1,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            width: "100%",
            borderRadius: "10px",
            "& p": {
              pb: 1,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: "22px",
              fontWeight: 600,
              textAlign: "center",
              mb: 2,
              color: "#818DCB",
            }}
          >
            Pay Balance
          </Typography>

          {loading ? (
            <Typography textAlign={"center"}>Loading...</Typography>
          ) : depositData.status == 1 ? 
          (
            <>
              <Typography sx={{ fontSize: "18px" , textAlign:"center" }}> Payment for this registration has already been received.</Typography>
              </>              
          )
          :
          (
            
            <>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Student Name</b>:{" "}
                {depositData?.firstname + " " + depositData?.lastname}
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Course Name</b>: {depositData.course_name}
              </Typography>
              <Typography sx={{ fontSize: "18px" }}>
                <b>Balance Amount</b>: ${depositData.paymentAmount}
              </Typography>
              <Typography sx={{ fontSize: "18px" , marginBottom: "20px" }}>
                <b>Balance Due Date</b>:{" "}
                {new Date(depositData.paymentDate * 1000).toLocaleDateString(
                  "en-US",
                  {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }
                )}
              </Typography>
              <div id="paypal-button-container"></div>

            </>
          )}



  <Modal
        isOpen={successModal}
        toggle={successToggleModal}
        className="connect-box"
        centered={true}
      >
        <ModalHeader toggle={successToggleModal}>
          <span className="ml-1 roititle font-weight-bold">Success</span>
        </ModalHeader>
        <ModalBody>
                              <p style={{textAlign: "center"}}>Thank You! Your payment has been received</p>

          </ModalBody>
          </Modal>

             <Modal
                  isOpen={loaderModal}
                  toggle={loaderToggle}
                  style={{height: "700px"}}
                  className="connect-box"
                  centered={true}
                >
                  <ModalHeader toggle={loaderToggle}>
                    <span className="ml-1 roititle font-weight-bold">
                       Processing Payment...
                    </span>
                  </ModalHeader>
                  <ModalBody  style={{maxHeight: "700px"}}>
                    <p style={{textAlign: "center"}}>Please wait while we process your payment.</p>
                  </ModalBody>
                  </Modal>
          
        </Box>
      </Box>
    </Box>
  );
};

export default PayDeposit;
